import React from 'react';

import HiddenTasksList from './HiddenTasksList';
import RightSidebarSearchForm from '../_earnMoneyCommon/RightSidebarSearchForm';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import GroupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchCollector';
import groupsSearchItem from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(HiddenTasksList);
const Content = ColumnsContent(
  GroupsSearchCollector(props => (
    <GroupsSearchItem
      {...props}
      groupName="tasksListChosenTasks"
      listReduceName="tasksModule.lists.tasksListHideTasks"
    />
  )),
  () => (
    <RightSidebarSearchForm listReduceName="tasksModule.lists.tasksListHideTasks" />
  )
);

export default props => <Content {...props} />;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/HiddenTasksList/index.js